import React from "react";
import PropTypes from "prop-types";
import { CustomIconButton, icon, IconComponent } from "../../../common/components";
import { translate } from "../../../common/providers";
import styles from "./UnnotifiedDocumentsAlert.module.css";

const UnnotifiedDocumentsAlert = ({ count, onDismiss }) => {
	if (!count || count <= 0) {
		return null;
	}

	return (
		<div className={styles.alertContainer}>
			<div className={styles.contentWrapper}>
				<IconComponent className={styles.icon} color="var(--red-500)" icon={icon.faExclamationTriangle} />
				<div className={styles.textContent}>
					<span className={styles.title}>{translate("common:alerts.distribution-notification-title")}</span>
					<div className={styles.message}>
						{translate("common:alerts.unnotified-documents-warning", { count })}
					</div>
				</div>
			</div>
			<CustomIconButton
				aria-label="dismiss"
				className={styles.closeButton}
				color="var(--grey-500)"
				icon={icon.faXmark}
				size="sm"
				variant="text"
				onClick={onDismiss}
			/>
		</div>
	);
};

UnnotifiedDocumentsAlert.propTypes = {
	count: PropTypes.number,
	onDismiss: PropTypes.func.isRequired,
};

UnnotifiedDocumentsAlert.defaultProps = {
	count: 0,
};

export default UnnotifiedDocumentsAlert;
